/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const COURSE_SUCCESS = 'COURSE_SUCCESS';
export const COURSE_BEGIN = 'COURSE_BEGIN';
export const COURSE_FAILURE = 'COURSE_FAILURE';
export const COURSE_CLEAR = 'COURSE_CLEAR';

export const COURSE_FILTER_SUCCESS = 'COURSE_FILTER_SUCCESS';
export const COURSE_FILTER_BEGIN = 'COURSE_FILTER_BEGIN';
export const COURSE_FILTER_FAILURE = 'COURSE_FILTER_FAILURE';
export const COURSE_FILTER_CLEAR = 'COURSE_FILTER_CLEAR';

export const COURSE_CATEGORYAVAILABLE_SUCCESS = 'COURSE_CATEGORYAVAILABLE_SUCCESS';
export const COURSE_CATEGORYAVAILABLE_BEGIN = 'COURSE_CATEGORYAVAILABLE_BEGIN';
export const COURSE_CATEGORYAVAILABLE_FAILURE = 'COURSE_CATEGORYAVAILABLE_FAILURE';
export const COURSE_CATEGORYAVAILABLE_CLEAR = 'COURSE_CATEGORYAVAILABLE_CLEAR';

export const COURSE_CATEGORYAVAILABLE_APPROVE_SUCCESS = 'COURSE_CATEGORYAVAILABLE_APPROVE_SUCCESS';
export const COURSE_CATEGORYAVAILABLE_APPROVE_BEGIN = 'COURSE_CATEGORYAVAILABLE_APPROVE_BEGIN';
export const COURSE_CATEGORYAVAILABLE_APPROVE_FAILURE = 'COURSE_CATEGORYAVAILABLE_APPROVE_FAILURE';
export const COURSE_CATEGORYAVAILABLE_APPROVE_CLEAR = 'COURSE_CATEGORYAVAILABLE_APPROVE_CLEAR';

export const COURSE_CATEGORY_SUCCESS = 'COURSE_CATEGORY_SUCCESS';
export const COURSE_CATEGORY_BEGIN = 'COURSE_CATEGORY_BEGIN';
export const COURSE_CATEGORY_FAILURE = 'COURSE_CATEGORY_FAILURE';
export const COURSE_CATEGORY_CLEAR = 'COURSE_CATEGORY_CLEAR';

export const COURSE_CATEGORY_APPROVE_SUCCESS = 'COURSE_CATEGORY_APPROVE_SUCCESS';
export const COURSE_CATEGORY_APPROVE_BEGIN = 'COURSE_CATEGORY_APPROVE_BEGIN';
export const COURSE_CATEGORY_APPROVE_FAILURE = 'COURSE_CATEGORY_APPROVE_FAILURE';
export const COURSE_CATEGORY_APPROVE_CLEAR = 'COURSE_CATEGORY_APPROVE_CLEAR';

export const COURSE_CLIENTPROCEDUREAVAILABLE_SUCCESS = 'COURSE_CLIENTPROCEDUREAVAILABLE_SUCCESS';
export const COURSE_CLIENTPROCEDUREAVAILABLE_BEGIN = 'COURSE_CLIENTPROCEDUREAVAILABLE_BEGIN';
export const COURSE_CLIENTPROCEDUREAVAILABLE_FAILURE = 'COURSE_CLIENTPROCEDUREAVAILABLE_FAILURE';
export const COURSE_CLIENTPROCEDUREAVAILABLE_CLEAR = 'COURSE_CLIENTPROCEDUREAVAILABLE_CLEAR';

export const COURSE_CLIENTPROCEDURE_SUCCESS = 'COURSE_CLIENTPROCEDURE_SUCCESS';
export const COURSE_CLIENTPROCEDURE_BEGIN = 'COURSE_CLIENTPROCEDURE_BEGIN';
export const COURSE_CLIENTPROCEDURE_FAILURE = 'COURSE_CLIENTPROCEDURE_FAILURE';
export const COURSE_CLIENTPROCEDURE_CLEAR = 'COURSE_CLIENTPROCEDURE_CLEAR';

export const COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_SUCCESS = 'COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_SUCCESS';
export const COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_BEGIN = 'COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_BEGIN';
export const COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_FAILURE = 'COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_FAILURE';
export const COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_CLEAR = 'COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_CLEAR';

export const COURSE_HOMOLOGOUSPROCEDURE_SUCCESS = 'COURSE_HOMOLOGOUSPROCEDURE_SUCCESS';
export const COURSE_HOMOLOGOUSPROCEDURE_BEGIN = 'COURSE_HOMOLOGOUSPROCEDURE_BEGIN';
export const COURSE_HOMOLOGOUSPROCEDURE_FAILURE = 'COURSE_HOMOLOGOUSPROCEDURE_FAILURE';
export const COURSE_HOMOLOGOUSPROCEDURE_CLEAR = 'COURSE_HOMOLOGOUSPROCEDURE_CLEAR';

export const COURSE_TESTAVAILABLE_SUCCESS = 'COURSE_TESTAVAILABLE_SUCCESS';
export const COURSE_TESTAVAILABLE_BEGIN = 'COURSE_TESTAVAILABLE_BEGIN';
export const COURSE_TESTAVAILABLE_FAILURE = 'COURSE_TESTAVAILABLE_FAILURE';
export const COURSE_TESTAVAILABLE_CLEAR = 'COURSE_TESTAVAILABLE_CLEAR';

export const COURSE_TEST_SUCCESS = 'COURSE_TEST_SUCCESS';
export const COURSE_TEST_BEGIN = 'COURSE_TEST_BEGIN';
export const COURSE_TEST_FAILURE = 'COURSE_TEST_FAILURE';
export const COURSE_TEST_CLEAR = 'COURSE_TEST_CLEAR';

export const COURSE_WORKCYCLEAVAILABLE_SUCCESS = 'COURSE_WORKCYCLEAVAILABLE_SUCCESS';
export const COURSE_WORKCYCLEAVAILABLE_BEGIN = 'COURSE_WORKCYCLEAVAILABLE_BEGIN';
export const COURSE_WORKCYCLEAVAILABLE_FAILURE = 'COURSE_WORKCYCLEAVAILABLE_FAILURE';
export const COURSE_WORKCYCLEAVAILABLE_CLEAR = 'COURSE_WORKCYCLEAVAILABLE_CLEAR';

export const COURSE_WORKCYCLE_SUCCESS = 'COURSE_WORKCYCLE_SUCCESS';
export const COURSE_WORKCYCLE_BEGIN = 'COURSE_WORKCYCLE_BEGIN';
export const COURSE_WORKCYCLE_FAILURE = 'COURSE_WORKCYCLE_FAILURE';
export const COURSE_WORKCYCLE_CLEAR = 'COURSE_WORKCYCLE_CLEAR';


export function fetchCourse(params = {}) {
    return async dispatch => {
        dispatch(courseClear());
        dispatch(courseBegin());
        await ApiService.getCourses(params)
			.then(
				result => {
                    let normalized = normalizeById(result.Data, 'idCourse');
                    dispatch(courseAdd(normalized));
					return normalized;
				},
				error => {
                    dispatch(courseError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchCourseFilter(params) {
    return async dispatch => {
        dispatch(courseFilterClear());
        dispatch(courseFilterBegin());
        await ApiService.getCoursesFilter(params)
            .then(
            result => {
                    dispatch(courseFilterAdd(result));
                },
                error => {
                    dispatch(courseFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCategoryAvailableCourseById(data, target) {
    return async dispatch => {
        dispatch(courseCategoryAvailableClear(target));
        dispatch(courseCategoryAvailableBegin());
        await ApiService.getCourseCategoriesAvailablebyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(courseCategoryAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseCategoryAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCategoryAvailableCourseApproveById(data, target) {
    return async dispatch => {
        dispatch(courseCategoryAvailableApproveClear(target));
        dispatch(courseCategoryAvailableApproveBegin());
        await ApiService.getCourseCategoriesAvailablebyId(data).then(
            result => {
                let normalized = normalizeById(result.Data, 'idCategory');
                dispatch(courseCategoryAvailableApproveAdd(normalized));
                return normalized;
            },
            error => {
                dispatch(courseCategoryAvailableApproveError());
                throw ({ error: error, message: 'An error ocurred' });
            }
        )
    }
}

export function fetchCategoryCourseById(data) {
    return async dispatch => {
        dispatch(courseCategoryClear());
        dispatch(courseCategoryBegin());
        await ApiService.getCourseCategoriesbyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(courseCategoryAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseCategoryError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCategoryCourseApproveById(data) {
    return async dispatch => {
        dispatch(courseCategoryApproveClear());
        dispatch(courseCategoryApproveBegin());
        await ApiService.getCourseCategoriesbyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(courseCategoryApproveAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseCategoryApproveError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchClientProcedureAvailableCourseById(data) {
    return async dispatch => {
        dispatch(courseClientProcedureAvailableClear());
        dispatch(courseClientProcedureAvailableBegin());
        await ApiService.getCourseClientProceduresAvailablebyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idProcedure');
                    dispatch(courseClientProcedureAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseClientProcedureAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchClientProcedureCourseById(data) {
    return async dispatch => {
        dispatch(courseClientProcedureClear());
        dispatch(courseClientProcedureBegin());
        await ApiService.getCourseClientProceduresbyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idProcedure');
                    dispatch(courseClientProcedureAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseClientProcedureError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchHomologousProcedureAvailableCourseById(data) {
    return async dispatch => {
        dispatch(courseHomologousProcedureAvailableClear());
        dispatch(courseHomologousProcedureAvailableBegin());
        await ApiService.getCourseHomologousProcedureAvailablebyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idProcedure');
                    dispatch(courseHomologousProcedureAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseHomologousProcedureAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchHomologousProcedureCourseById(data) {
    return async dispatch => {
        dispatch(courseHomologousProcedureClear());
        dispatch(courseHomologousProcedureBegin());
        await ApiService.getCourseHomologousProcedurebyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idProcedure');
                    dispatch(courseHomologousProcedureAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseHomologousProcedureError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchTestAvailableCourseById(idCourse, idTraining) {
    return async dispatch => {
        dispatch(courseTestAvailableBegin());
        await ApiService.getCoursesTestsAvailable(idCourse, idTraining)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idTest');
                    dispatch(courseTestAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseTestAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchTestCourseById(data) {
    return async dispatch => {
        dispatch(courseTestClear());
        dispatch(courseTestBegin());
        await ApiService.getCoursesTests(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idTest');
                    dispatch(courseTestAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseTestError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchWorkCycleAvailableCourseById(data) {
    return async dispatch => {
        dispatch(courseWorkCycleAvailableClear());
        dispatch(courseWorkCycleAvailableBegin());
        await ApiService.getCoursesWorkCyclesAvailable(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idTest');
                    dispatch(courseWorkCycleAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseWorkCycleAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchWorkCycleCourseById(data) {
    return async dispatch => {
        dispatch(courseWorkCycleClear());
        dispatch(courseWorkCycleBegin());
        await ApiService.getCoursesWorkCycles(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idTest');
                    dispatch(courseWorkCycleAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(courseWorkCycleError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}


//Course
export const courseBegin = () => ({
    type: COURSE_BEGIN,
});

export const courseAdd = data => ({
    type: COURSE_SUCCESS,
	payload: { data }
})

export const courseError = () => ({
    type: COURSE_FAILURE,
})

export const courseClear = () =>({
    type: COURSE_CLEAR,
})

//CourseFilter
export const courseFilterBegin = () => ({
    type: COURSE_FILTER_BEGIN,
});

export const courseFilterAdd = filterData => ({
    type: COURSE_FILTER_SUCCESS,
    payload: { filterData }
})

export const courseFilterError = () => ({
    type: COURSE_FILTER_FAILURE,
})

export const courseFilterClear = () => ({
    type: COURSE_FILTER_CLEAR,
})

//CourseCategoryAvailable
export const courseCategoryAvailableBegin = () => ({
    type: COURSE_CATEGORYAVAILABLE_BEGIN,
});

export const courseCategoryAvailableAdd = data => ({
    type: COURSE_CATEGORYAVAILABLE_SUCCESS,
    payload: { data }
})

export const courseCategoryAvailableError = () => ({
    type: COURSE_CATEGORYAVAILABLE_FAILURE,
})

export const courseCategoryAvailableClear = (target) => ({
    type: COURSE_CATEGORYAVAILABLE_CLEAR,
    payload: target
})

//Approve
export const courseCategoryAvailableApproveClear = (target) => ({
    type: COURSE_CATEGORYAVAILABLE_APPROVE_CLEAR,
    payload: target
})

export const courseCategoryAvailableApproveBegin = () => ({
    type: COURSE_CATEGORYAVAILABLE_APPROVE_BEGIN,
})

export const courseCategoryAvailableApproveAdd = data => ({
    type: COURSE_CATEGORYAVAILABLE_APPROVE_SUCCESS,
    payload: { data }
})

export const courseCategoryAvailableApproveError = () => ({
    type: COURSE_CATEGORYAVAILABLE_APPROVE_FAILURE
})

//CourseCategory
export const courseCategoryBegin = () => ({
    type: COURSE_CATEGORY_BEGIN,
});

export const courseCategoryAdd = data => ({
    type: COURSE_CATEGORY_SUCCESS,
    payload: { data }
})

export const courseCategoryError = () => ({
    type: COURSE_CATEGORY_FAILURE,
})

export const courseCategoryClear = () => ({
    type: COURSE_CATEGORY_CLEAR,
})

//Approve
export const courseCategoryApproveBegin = () => ({
    type: COURSE_CATEGORY_APPROVE_BEGIN,
});

export const courseCategoryApproveAdd = data => ({
    type: COURSE_CATEGORY_APPROVE_SUCCESS,
    payload: { data }
})

export const courseCategoryApproveError = () => ({
    type: COURSE_CATEGORY_APPROVE_FAILURE,
})

export const courseCategoryApproveClear = () => ({
    type: COURSE_CATEGORY_APPROVE_CLEAR,
})

//ClientProcedureAvailable
export const courseClientProcedureAvailableBegin = () => ({
    type: COURSE_CLIENTPROCEDUREAVAILABLE_BEGIN,
});

export const courseClientProcedureAvailableAdd = data => ({
    type: COURSE_CLIENTPROCEDUREAVAILABLE_SUCCESS,
    payload: { data }
})

export const courseClientProcedureAvailableError = () => ({
    type: COURSE_CLIENTPROCEDUREAVAILABLE_FAILURE,
})

export const courseClientProcedureAvailableClear = () => ({
    type: COURSE_CLIENTPROCEDUREAVAILABLE_CLEAR,
})

//ClientProcedure
export const courseClientProcedureBegin = () => ({
    type: COURSE_CLIENTPROCEDURE_BEGIN,
});

export const courseClientProcedureAdd = data => ({
    type: COURSE_CLIENTPROCEDURE_SUCCESS,
    payload: { data }
})

export const courseClientProcedureError = () => ({
    type: COURSE_CLIENTPROCEDURE_FAILURE,
})

export const courseClientProcedureClear = () => ({
    type: COURSE_CLIENTPROCEDURE_CLEAR,
})

//HomologousProcedureAvailable
export const courseHomologousProcedureAvailableBegin = () => ({
    type: COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_BEGIN,
});

export const courseHomologousProcedureAvailableAdd = data => ({
    type: COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_SUCCESS,
    payload: { data }
})

export const courseHomologousProcedureAvailableError = () => ({
    type: COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_FAILURE,
})

export const courseHomologousProcedureAvailableClear = () => ({
    type: COURSE_HOMOLOGOUSPROCEDUREAVAILABLE_CLEAR,
})

//HomologousProcedure
export const courseHomologousProcedureBegin = () => ({
    type: COURSE_HOMOLOGOUSPROCEDURE_BEGIN,
});

export const courseHomologousProcedureAdd = data => ({
    type: COURSE_HOMOLOGOUSPROCEDURE_SUCCESS,
    payload: { data }
})

export const courseHomologousProcedureError = () => ({
    type: COURSE_HOMOLOGOUSPROCEDURE_FAILURE,
})

export const courseHomologousProcedureClear = () => ({
    type: COURSE_HOMOLOGOUSPROCEDURE_CLEAR,
})

//CourseTestAvailable
export const courseTestAvailableBegin = () => ({
    type: COURSE_TESTAVAILABLE_BEGIN,
});

export const courseTestAvailableAdd = data => ({
    type: COURSE_TESTAVAILABLE_SUCCESS,
    payload: { data }
})

export const courseTestAvailableError = () => ({
    type: COURSE_TESTAVAILABLE_FAILURE,
})

export const courseTestAvailableClear = () => ({
    type: COURSE_TESTAVAILABLE_CLEAR,
})

//CourseTest
export const courseTestBegin = () => ({
    type: COURSE_TEST_BEGIN,
});

export const courseTestAdd = data => ({
    type: COURSE_TEST_SUCCESS,
    payload: { data }
})

export const courseTestError = () => ({
    type: COURSE_TEST_FAILURE,
})

export const courseTestClear = () => ({
    type: COURSE_TEST_CLEAR,
})

//CourseWorkCycleAvailable
export const courseWorkCycleAvailableBegin = () => ({
    type: COURSE_WORKCYCLEAVAILABLE_BEGIN,
});

export const courseWorkCycleAvailableAdd = data => ({
    type: COURSE_WORKCYCLEAVAILABLE_SUCCESS,
    payload: { data }
})

export const courseWorkCycleAvailableError = () => ({
    type: COURSE_WORKCYCLEAVAILABLE_FAILURE,
})

export const courseWorkCycleAvailableClear = () => ({
    type: COURSE_WORKCYCLEAVAILABLE_CLEAR,
})


//CourseWorkCycle
export const courseWorkCycleBegin = () => ({
    type: COURSE_WORKCYCLE_BEGIN,
});

export const courseWorkCycleAdd = data => ({
    type: COURSE_WORKCYCLE_SUCCESS,
    payload: { data }
})

export const courseWorkCycleError = () => ({
    type: COURSE_WORKCYCLE_FAILURE,
})

export const courseWorkCycleClear = () => ({
    type: COURSE_WORKCYCLE_CLEAR,
})